export default "__VITE_PUBLIC_ASSET__f662a3ef__"